<template>
  <div class="divSelect">
    <div class="divTree">
      <Tree v-for="mm in dsTree" :key="mm.fid" :p_node="mm" :a_pk="pkNode"/>
      <!--<Treeselect :options="dsTree" aria-placeholder="aaa"/>--->
    </div>
    <div class="divSelect1">
      <div class="divFlex">
        <p class="flexRowL"><input v-model="vLike" placeholder="编号|名称"></p>
        <p class="flexRowR">
          <button @click="getDs">查询</button>
          <button @click="a_close">关闭</button>
        </p>
      </div>
      <div class="divSelect2">
        <table>
          <thead>
            <tr class="tbListHead">
              <th style="width: 5px;"/>
              <th v-for="item in colms" :key="item.vkey">{{ item.vlabel }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,idx) in options" :key="idx" @click="toPick(item)" @dblclick="toPick2(item,idx)" >
              <td>{{ idx+1 }}</td>
              <td v-for="clm in colms" :key="clm.vkey" :class="item.picked?'tdPick':''">{{ comm.mkTdHtml(item,clm) }}</td>
              <!--<td>{{ item[clm.vkey] }}</td>-->
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import comm from '../../utils/comm'
import Tree from '../c3_tools/06_tree.vue'
// import Treeselect from '@riophae/vue-treeselect'
// import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default{
  name: 'CPicker',
  components: {
    // Treeselect,
    Tree
  },
  props: {
    p_ipt: {
      type: Object,
      default: function() {
        return {}
      }
    },
    a_pickup: {
      type: Function,
      default: null
    },
    a_close: {
      type: Function,
      default: null
    }
  },
  data: function() {
    return {
      vLike: '',
      searchRow: {},
      colms: [],
      options: [],
      bbPick: false,
      dsTree: []// fid，fname，fexpand，fchildren
    }
  },
  watch: {
    p_ipt: {
      handler(newV, oldV) {
      },
      immediate: true// deep: true
    }
  },
  methods: {
    prt(a, b) {
      console.log(`c3_3_pick.${a}`, b)
    },
    initDs() {
      comm.pkDbData('type' + this.p_ipt.vptype, rs => {
        if (rs !== 'empty' && rs.length > 0) {
          this.dsTree = rs.sort(this.comm.sortArr('fcode', true))
        }
      })
      this.getDs()
    }, // 不用了
    getDs() {
      this.searchRow['iAct'] = this.p_ipt.vpact
      this.searchRow['fidmenu'] = this.p_ipt.vptype
      if (this.comm.toNum(this.p_ipt.relate) > 0) {
        const relateVal = this.p_ipt[this.p_ipt.relate]
        if (!relateVal || relateVal === '') {
          return
        }
        this.searchRow[this.p_ipt.relate] = this.p_ipt[this.p_ipt.relate]// this.mkLike(this.p_ipt[this.p_ipt.relate])
      }
      if (this.vLike !== '') {
        this.searchRow['fcode'] = this.mkLike(this.vLike)
      }
      this.$iPost(this.p_ipt.vpurl, this.searchRow).then(
        rs => {
          // comm.putDbData('type' + this.p_ipt.vptype, rs.data)
          const vo = comm.mkColmns(rs.data.data)
          this.prt('getDs.rs', rs)
          this.prt('getDs.vo', vo)
          this.colms = vo.colms
          this.options = vo.data
        }
      ).catch()
    },
    itemFinder(item, vLike) {
      // console.log('c3_1_picker.itemFinder', (item.fcode + item.fname).indexOf(vLike))
      return (item.fcode + item.fname).indexOf(vLike) > -1
      // return !!(item.fcode + item.fname).toLowerCase().match(vLike.toLowerCase())
    },
    toPick(item) {
      if (this.p_ipt.bbMutip) return
      this.a_pickup(item)
    }, // 单击，表头用
    toPick2(item, idx) {
      this.prt('toPick2', item)
      if (!this.p_ipt.bbMutip) return
      this.options.splice(idx, 1)
      this.a_pickup(item)
    }, // 双击，表体

    mkLike(val) {
      this.prt('mkLike', val)
      return this.$keys().like + val + this.$keys().like
    },
    pkNode(node) {
      this.prt('03_pick.pkNode', node)
      if (node['fchildren'])node['fexpand'] = !node['fexpand']
      else {
        this.searchRow['fidparent'] = node.fid
        this.getDs()
      }
    }
  }
}
</script>
<style scoped>/** */
.divSelect{
  position: absolute;
  background-color: rgba(0, 0, 0, 0.158);
  top: 0;
  left: 0;
  width: 90%;
  height: 75%;
  margin: 0;
  padding: 5%;
  z-index: 40;
  display: flex;
}

.divTree{
  height: 96%;
  overflow: auto;
  background-color: white; /***/
  width: 26%;
  padding: 2% 1%;
  border-right: 1px solid #ccc;
}
.divSelect1{
  height: 96%;
  background-color: white; /***/
  display: flex;
  flex-direction: column;
  width: 70%;
  padding: 2% 1%;
}
.divFlex{
  width: 100%;
}
.flexRowL{
  float: left;
  display: block;
  width: 65%;
  text-align: right;
  overflow: hidden;
  padding-right: 2%;
}
.flexRowL input{
  width: 150px;
}
.flexRowR{
  float: left;
  display: block;
  width: 30%;
  overflow: hidden;
}
.divSelect2{
  margin-top: 2%;
  height: 90%;/**350px; */
  overflow: auto;
}
.divSelect2 table{
  border-collapse: collapse;
  border-spacing: 0;
  white-space: nowrap;
  width: 100%;
}
.divSelect2 table tr :hover{
  cursor: pointer;
}
.divSelect2 table td{
  border:1px solid rgba(237, 236, 255, 0.938);
  /** */
  padding: 3px 5px;
}
.tdPick{
  color:rgb(45, 45, 230);
}
.tdNull{
  background-color: white;
}
.tbListHead th{
  /*
  border: 1px solid rgba(168, 168, 168, 0.103);
  font-weight: normal;
  padding: 5px 2px;
  background-image: linear-gradient(white,rgb(233, 233, 233),rgb(240, 240, 240),rgb(233, 233, 233),white);
  */
  background-color: rgba(7, 70, 95, 0.904);
  color:aliceblue;
  text-align: center;
  position: sticky;
  top:0px;
}
</style>



// WEBPACK FOOTER //
// src/comps/c3_tools/03_picker.vue